export const LayoutType = {
  Small: 0,
  SmallWithPopout: 1,
  SmallWithPeninsula: 2,
  SmallWithIsland: 3,
  SmallWithPopoutWithPeninsula: 4,
  SmallWithPopoutWithIsland: 5,
  SmallWithPeninsulaWithIsland: 6,
  SmallWithPopoutWithPeninsulaWithIsland: 7,
  LShape: 8,
  LShapeWithPeninsula: 9,
  LShapeWithIsland: 10,
  LShapeWithPeninsulaWithIsland: 11,
};

export const LayoutAbbreviation = {
  All: "ALL",
  Small: "S",
  SmallWithPopout: "SP",
  SmallWithPeninsula: "SN",
  SmallWithIsland: "SI",
  SmallWithPopoutWithPeninsula: "SPN",
  SmallWithPopoutWithIsland: "SPI",
  SmallWithPeninsulaWithIsland: "SNI",
  SmallWithPopoutWithPeninsulaWithIsland: "SPNI",
  LShape: "L",
  LShapeWithPeninsula: "LN",
  LShapeWithIsland: "LI",
  LShapeWithPeninsulaWithIsland: "LNI",
};

export const LayoutAbbreviations = ["S","SP","SN","SI","SPN","SPI","SNI","SPNI","L","LN","LI","LNI"];
export const LayoutAbbreviationsToRemove = ["LSP","LNI","LI","LN","L","SPNI","SNI","SPI","SPN","SI","SN","SP","S"];

export const PLACEMENTS = {
  Island: "Island",
  Countertop: "Countertop"
};

export const MODULE_CONTEXT_MENU_TYPES = {
  Filters: "Filters",
  SliceButtons: "SliceButtons",
};
export const MODULE_CONTEXT_MENU_DIRECTIONS = {
  Vertical: "Vertical",
  Horizontal: "Horizontal"
};

export const CABINET_WIZARD_BUTTONS = [{
  text: "All products",
  buttonId: "all_products",
},{
  text: "Door style",
  filtersGroupName: "DoorStyle",
  buttonId: "door_style",
},{
  text: "Wood type",
  filtersGroupName: "WoodType",
  buttonId: "wood_type",
},{
  text: "Stain / color",
  filtersGroupName: "StainColor",
  buttonId: "stain_color",
},{
  text: "Inlay type",
  filtersGroupName: "Inlay Type",
  buttonId: "inlay_type",
}];

export const COUNTERTOP_WIZARD_BUTTONS = [{
  text: "Stone",
  pluralText: "Stones",
  buttonId: "all_products",
},{
  text: "Color",
  pluralText: "Color",
  filtersGroupName: "Stone Color",
  buttonId: "color",
},{
  text: "Material",
  pluralText: "Materials",
  filtersGroupName: "Stone Material",
  buttonId: "materials",
},{
  text: "Edge",
  pluralText: "Edges",
  filtersGroupName: "Edge Profile",
  buttonId: "edges",
},{
  text: "Backsplash",
  pluralText: "Backsplash",
  buttonId: "backsplash",
}];

export const wizardAllButton = {
  id: "All",
  value: "All",
  displayText: "All",
  parent_id: null,
  icon: "",
  lockedInWizard: false,
  filterGroup_id: 0,
  additionalImages: []
};

export const BACKSPLASH_TYPES = ["4in", "6in", "18in"];

export const METADATA = {
  ALL: "ALL"
};

export const COUNTERTOP_GROUP = ["countertop", "center_island_countertop", "backsplash"];
export const CABINET_GROUP = ["top_cabinet", "bottom_cabinet", "center_island_cabinet", "fridge_enclosure", "tall_cabinet"];
export const EDGE_GROUP = ["edge", "edge_profile", "center_island_edge"];
